// @flow
import { path } from 'ramda'
import { getChannelGenres } from '@alphaott/api-client'
import { getPublicDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_CHANNEL_GENRES = 'channels/FETCH_GENRES'

const fetchChannelGenresAction = (serviceSpec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_CHANNEL_GENRES,
    payload: getChannelGenres(publicApi, serviceSpec),
    meta: { ttl },
  })
}

// eslint-disable-next-line complexity
export const fetchChannelGenres = (serviceSpec: string, force: ?boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchChannelGenresAction(serviceSpec))

  const state = getState()
  const expires = path(['channelGenres', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchChannelGenresAction(serviceSpec))
}
